import { render, staticRenderFns } from "./offerTable.vue?vue&type=template&id=80a853f6&scoped=true"
import script from "./offerTable.vue?vue&type=script&lang=js"
export * from "./offerTable.vue?vue&type=script&lang=js"
import style0 from "./offerTable.vue?vue&type=style&index=0&id=80a853f6&prod&lang=css"
import style1 from "../statistics/css/finance.css?vue&type=style&index=1&id=80a853f6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a853f6",
  null
  
)

export default component.exports